module.exports = "<div id=\"img-perspective-component\" class=\"block-highlight-center\" img-perspective>\n    <img id=\"img-computer\" class=\"tilt-effect\" [src]=\"imgFixed\" alt=\"\"/>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// /Users/davidlagace/Sites/david-lagace-website/src/app/components/img-perspective/img-perspective.component.html
// module id = ../../../../../src/app/components/img-perspective/img-perspective.component.html
// module chunks = main